import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import {styles} from './styles';
import {Props} from './type';

const PaperSheet = (props: Props) => {
    const {classes, title, message} = props;
    return (
        <div>
            <Paper className={classes.root} elevation={1}>
                <Typography variant="h5" component="h3">
                    {title}
                </Typography>
                <Typography component="p">
                    {message}
                </Typography>
            </Paper>
        </div >
    );
};

export default withStyles(styles)(PaperSheet);
